<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :bgColor="bgColor"
            :icons="icon_data"
            :load_url="load_url"
            :base-col-len="12"
            :hasLinks="hasLinks"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'OrdersoutstandingwithFlagsAccounting',
        components: {DashboardCard},
        props: {
            dataDisplay: {type:String, default: null},
            bgColor: {type: String, default: 'light'},
            width: {type: Number, default: 25}
        },
        data() {
            return {
                hasLinks: true,
                main_icon: 'fa-light fa-flag',
                color: '#d53a00',
                title: 'Payment Flags',
                load_url: '/dashboards/PaymentIssueFlags',
                icon_data: [
                    {
                        name: 'Payment - Return Check',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=5',
                        text_color: '#555'
                    },
                    {
                        name: 'Payment - Return ACH',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=6',
                        text_color: '#555'
                    },
                    {
                        name: 'Payment - PayPal Incomplete',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=7',
                        text_color: '#d9534f'
                    },
                    {
                        name: 'Payment - PayPal No Account', //Request Review (Renaming to "Re-appraise")
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=8',
                        text_color: '#555'
                    },
                    {
                        name: 'Rescind Offer', //Request Review (Renaming to "Re-appraise")
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=9',
                        text_color: '#555'
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>